module.exports = __webpack_public_path__ + "img/product-shot_03_loading.c5179a8b.jpg";